import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = ["data-fallback", "data-scope", "data-key"]
const _hoisted_3 = { class: "icon" }
const _hoisted_4 = { class: "field" }
const _hoisted_5 = { class: "control" }

import { InputVariableViewModel } from '../../../models/designer';
import Icon from '@/shared/icons/Icon.vue';
import AttributeIconUtil from '../../../../../shared/util/attributeIconUtil';
import { onBeforeMount, PropType, ref, computed } from 'vue';
import { Icons, IconType } from '@/shared/icons/icons';


export default /*@__PURE__*/_defineComponent({
  __name: 'VariableBadge',
  props: {
  id: {
    type: String,
    required: true,
  },
  variable: {
    type: Object as PropType<InputVariableViewModel>,
    required: true,
  },
  fallback: {
    type: String,
    default: '',
  },
},
  emits: ["closedFallback"],
  setup(__props, { expose: __expose, emit: __emit }) {

const props = __props;

const emit = __emit;

__expose({
  update,
});

const fallbackValue = ref('');
const isOpen = ref(false);
const invalid = ref(false);

onBeforeMount(() => {
  fallbackValue.value = props.fallback;
  invalid.value = !isValid();
});

function update() {
  invalid.value = !isValid();
}

const icon = computed<IconType>(() => {
  if (invalid.value) {
    return 'ErrorIcon';
  }

  return AttributeIconUtil.getIconType(props.variable.dataType, props.variable.key, false);
});

function getIconComponent() {
  return Icons[getIcon()];
}

function getIcon(): IconType {
  if (invalid.value) {
    return 'ErrorIcon';
  }

  return AttributeIconUtil.getIconType(props.variable.dataType, props.variable.key, false) || '';
}

function isValid(): boolean {
  return !props.variable.error;
}

function closeFallback() {
  isOpen.value = false;
  emit('closedFallback');
}

function getError() {
  if (props.variable.error) {
    return props.variable.error;
  }
}

return (_ctx: any,_cache: any) => {
  const _component_n_tooltip = _resolveComponent("n-tooltip")!
  const _component_VDropdown = _resolveComponent("VDropdown")!

  return (_openBlock(), _createElementBlock("div", {
    id: __props.id,
    class: "variable-badge",
    contenteditable: "false"
  }, [
    _createVNode(_component_VDropdown, {
      placement: "bottom",
      style: {"display":"inline-block"},
      shown: isOpen.value,
      disabled: invalid.value
    }, {
      popper: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _cache[2] || (_cache[2] = _createElementVNode("label", { class: "fallback-text label" }, "Fallback text will be used if the variable is not set", -1)),
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              class: "tooltip-content input",
              type: "text",
              placeholder: "Enter fallback text here",
              required: "",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((fallbackValue).value = $event)),
              onKeypress: _withKeys(closeFallback, ["enter"])
            }, null, 544), [
              [
                _vModelText,
                fallbackValue.value,
                void 0,
                { trim: true }
              ]
            ])
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_n_tooltip, {
          position: "top",
          text: getError()
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", {
              class: _normalizeClass(["pill", { error: invalid.value }]),
              "data-fallback": fallbackValue.value,
              "data-scope": __props.variable.scope,
              "data-key": __props.variable.key,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (isOpen.value = true))
            }, [
              _createElementVNode("span", _hoisted_3, [
                (__props.variable.scope === 'flow')
                  ? (_openBlock(), _createBlock(Icon, {
                      key: 0,
                      icon: "FlowVariableIcon"
                    }))
                  : _createCommentVNode("", true),
                (__props.variable.scope !== 'flow')
                  ? (_openBlock(), _createBlock(Icon, {
                      key: 1,
                      class: "material-badge-icon",
                      icon: icon.value
                    }, null, 8, ["icon"]))
                  : _createCommentVNode("", true)
              ]),
              _createTextVNode(" " + _toDisplayString(__props.variable.name), 1)
            ], 10, _hoisted_2)
          ]),
          _: 1
        }, 8, ["text"])
      ]),
      _: 1
    }, 8, ["shown", "disabled"])
  ], 8, _hoisted_1))
}
}

})